import React from "react";

const ClinicSvg = () => (
  <svg
    viewBox="0 0 111 117"
    css={`
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
    `}
  >
    <g clipPath="url(#prefix__clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.904 111.584h-21.19v-.043h5.405v-11.22c0-2.021-.163-4.002-.478-5.933a35.863 35.863 0 0 0 6.302-20.364c0-9.67-3.81-18.45-10.01-24.921 4.789-3.303 7.926-8.827 7.926-15.085 0-10.115-8.197-18.312-18.311-18.312-10.116 0-18.313 8.197-18.313 18.312 0 1.392.156 2.748.45 4.052a35.833 35.833 0 0 0-19.57 7.276c-.243-.007-.488-.01-.733-.01-14.627 0-26.477 11.851-26.477 26.476a26.388 26.388 0 0 0 7.4 18.361 36.621 36.621 0 0 0-1.425 10.148v11.22h5.405v.043H3.096V11.997h104.808v99.587z"
        fill="#7AC7C8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.641 94.388c-2.327-14.277-12.907-25.783-26.687-29.455-2.967-11.061-12.919-19.263-24.839-19.587a35.833 35.833 0 0 1 19.57-7.276c1.843 8.165 9.139 14.261 17.863 14.261 3.856 0 7.434-1.192 10.385-3.228 6.2 6.471 10.01 15.251 10.01 24.921a35.863 35.863 0 0 1-6.302 20.364z"
        fill="#60BFC2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.933 49.103c-6.556-6.842-15.786-11.102-26.012-11.102a36 36 0 0 0-2.236.069 18.405 18.405 0 0 1-.45-4.052c0-10.115 8.197-18.312 18.313-18.312 10.114 0 18.311 8.197 18.311 18.312 0 6.258-3.137 11.782-7.926 15.085z"
        fill="#60BFC2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.548 52.331c-8.724 0-16.02-6.096-17.863-14.261a36 36 0 0 1 2.236-.069c10.226 0 19.456 4.26 26.012 11.102a18.225 18.225 0 0 1-10.385 3.228z"
        fill="#49B8BC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.305 90.173a26.388 26.388 0 0 1-7.4-18.361c0-14.625 11.85-26.476 26.477-26.476.245 0 .49.003.733.01-8.64 6.58-14.218 16.977-14.218 28.678 0 1.483.09 2.943.264 4.379a36.446 36.446 0 0 0-5.856 11.77z"
        fill="#60BFC2"
      />
      <path
        d="M26.161 78.403a36.375 36.375 0 0 1-.264-4.379c0-11.701 5.578-22.098 14.218-28.678 11.92.324 21.872 8.526 24.839 19.587a36.69 36.69 0 0 0-9.459-1.233c-12 0-22.656 5.778-29.334 14.703z"
        fill="#49B8BC"
      />
      <path
        d="M111 11.997h-3.096V6.775H3.096v5.222H0V.875h111v11.122z"
        fill="#4CBABE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.096 11.997h104.808V6.775H3.096v5.222z"
        fill="#29A4A9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.88 111.541h73.239v-11.22c0-20.225-16.394-36.621-36.624-36.621-20.217 0-36.615 16.396-36.615 36.621v11.22zM24.285 117h62.429v-5.416H24.285V117z"
        fill="#4CBABE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.285 111.584h62.429v-.043H24.285v.043z"
        fill="#29A4A9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.714 111.541H24.285v-11.037c0-17.24 13.978-31.216 31.211-31.216 17.243 0 31.218 13.976 31.218 31.216v11.037z"
        fill="#21969F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.041 35.74c0 10.239-8.3 18.542-18.541 18.542S36.959 45.979 36.959 35.74c0-10.24 8.3-18.54 18.541-18.54s18.541 8.3 18.541 18.54zM32.237 27.558c0 5.72-4.636 10.357-10.357 10.357-5.722 0-10.358-4.637-10.358-10.357 0-5.721 4.636-10.358 10.358-10.358 5.721 0 10.357 4.637 10.357 10.358zM32.237 54.282c0 5.721-4.636 10.358-10.357 10.358-5.722 0-10.358-4.637-10.358-10.358 0-5.72 4.636-10.357 10.358-10.357 5.721 0 10.357 4.637 10.357 10.357zM99.477 27.558c0 5.72-4.637 10.357-10.358 10.357-5.722 0-10.357-4.637-10.357-10.357 0-5.721 4.635-10.358 10.357-10.358 5.721 0 10.358 4.637 10.358 10.358zM99.477 54.282c0 5.721-4.637 10.358-10.358 10.358-5.722 0-10.357-4.637-10.357-10.358 0-5.72 4.635-10.357 10.357-10.357 5.721 0 10.358 4.637 10.358 10.357z"
        fill="#D6EDED"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.522 38.133h20.715v-4.114H11.522v4.114zM45.142 38.133h20.715v-4.114H45.142v4.114z"
        fill="#4CBABE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.443 46.433h4.113V25.718h-4.113v20.715zM11.522 64.639h20.715v-4.114H11.522v4.114zM78.762 38.133h20.715v-4.114H78.762v4.114zM78.762 64.639h20.715v-4.114H78.762v4.114zM54 114.366h3V66.455h-3v47.911z"
        fill="#4CBABE"
      />
    </g>
    <defs>
      <clipPath id="prefix__clip0">
        <path fill="#fff" d="M0 0h111v117H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default ClinicSvg;
